<template>
  <div class="platform-icon">
    <BaseIcon name="square-filled" v-if="platformColor" class="platform-icon__icon" :color="platformColor" />
    <div v-else class="platform-icon__fallback">
      <span class="platform-icon__fallback--icon">?</span>
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon.vue';

export default {
  name: 'PlatformIcon',
  components: { BaseIcon },
  props: {
    platform: {
      type: String,
    },
  },
  data: () => ({
    platformColors: {
      alberta: '#00AAD3',
      biddingo: '#0078D4',
      bidsandtenders: '#2F8968',
      bonfire: '#F79534',
      british_columbia: '#004A8E',
      bsdq: '#00ACEB',
      buyandsell: '#D40000',
      canada_buys: '#D40000',
      constructo: '#D69F28',
      hydroquebec: '#FF9A00',
      infrastructure_ontario: '#000000',
      jaggaer: '#E01C1B',
      merx: '#FF030B',
      new_brunswick: '#881211',
      newfoundland_and_labrador: '#E31B23',
      northwest_territories: '#EA3D4E',
      nova_scotia: '#116CB5',
      nunavut: '#509AC3',
      pige_quebec: '#0083D5',
      prince_edward_island: '#00421B',
      saskatchewan: '#FFEA37',
      seao_v2: '#00619E',
      seao: '#00619E',
      yukon: '#F2B128',
    },
  }),
  computed: {
    platformColor() {
      return this.platformColors[this.platform.toLowerCase()];
    },
  },
};
</script>

<style lang="scss">
.platform-icon {
  width: min-content;

  &__icon {
    height: 14px;
    width: 14px;
    display: flex;
  }
  &__fallback {
    border-radius: $border-radius-large;
    height: 16px;
    width: 16px;
    border: 1.5px solid $color-neutral;
    justify-content: center;
    display: flex;

    &--icon {
      font-size: 12px;
      align-self: center;
      display: flex;
      color: $color-neutral;
    }
  }
}
</style>
